var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "184 -847.39 663.39 663.39",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390.15-184H216q-13.55 0-22.77-9.23Q184-202.45 184-216v-174.15q26.15-12 41.08-36.81Q240-451.77 240-480t-14.92-53.04q-14.93-24.81-41.08-36.81V-744q0-13.55 9.23-22.77Q202.45-776 216-776h168q10.77-32.31 36.62-51.85t59.15-19.54q33.31 0 59.38 19.38Q565.23-808.63 576-776h168q13.55 0 22.77 9.23Q776-757.55 776-744v168q32.31 10.77 51.85 36.62t19.54 59.15q0 33.31-19.38 59.38Q808.63-394.77 776-384v168q0 13.55-9.23 22.77Q757.55-184 744-184H569.85q-12.77-26.15-36.69-41.08Q509.24-240 480.12-240t-53.16 14.92q-24.04 14.93-36.81 41.08M216-216h158.92q13.08-18.85 37.27-37.42Q436.38-272 480-272t67.81 18.58Q572-234.85 585.08-216H744v-195.38h10.46q30.37-4.62 45.65-24.9 15.27-20.27 15.27-43.72t-15.27-43.72q-15.28-20.28-45.65-24.9H744V-744H548.62v-10.46q-4.62-30.37-24.9-45.65-20.27-15.27-43.72-15.27t-43.72 15.27q-20.28 15.28-24.9 45.65V-744H216v155.08q28.08 17.69 42.04 47.27Q272-512.08 272-480q0 34.05-13.96 63.53Q244.08-387 216-371.08zm264-264"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtension);
export default __webpack_public_path__ + "static/media/extension.3b897965d04f5cb53aac8f2ae75aca40.svg";
export { ForwardRef as ReactComponent };